<template>
    <div>
        {{ currentValue.value }}
    </div>
</template>

<script>

export default {
    name: 'ModuleText',
    data () {
        return {
            currentValue: {
                value: null
            }
        }
    },
    props: {
        parameters: {
            type: Object,
        },
    },
    watch: {
        currentValue: {
            handler(val) {
                this.$emit('parameters-update', val);
            },
            deep: true
        },
        // update value from mqtt
        parameters: {
            handler(val) {
                if (val.value != this.currentValue.value)
                {
                    this.currentValue.value = val.value;
                }
            },
            deep: true
        }
    },
    mounted() {
        this.currentValue = JSON.parse(JSON.stringify(this.parameters));
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
